import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import Text from 'components/Text';
import Pill from 'components/Pill';
import { useAppNameContext } from 'hooks/useAppNameContext';
import { hasPrivilege, USER_READ } from 'utils/privileges';
function OwnerText(_ref) {
  var owner = _ref.owner;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var appNameContext = useAppNameContext();
  if (!owner) {
    return /*#__PURE__*/React.createElement(Text, null, t('property_no_owner'));
  }
  var isUserAdmin = hasPrivilege(USER_READ);
  var isDeleted = owner.isDeleted,
    id = owner.id,
    displayName = owner.displayName;
  var link = isDeleted ? "/users?search=".concat(encodeURIComponent("id:".concat(id, " userDomains.isDeleted:1"))) : "/users?search=".concat(encodeURIComponent("id:".concat(id)));
  if (isUserAdmin) {
    if (appNameContext === 'hub') {
      return /*#__PURE__*/React.createElement(Pill, {
        icon: "user",
        iconColor: "user",
        target: "_blank",
        as: "a",
        href: "/admin".concat(link)
      }, displayName);
    }
    return /*#__PURE__*/React.createElement(Pill, {
      icon: "user",
      iconColor: "user",
      as: NavLink,
      to: link
    }, displayName);
  }
  return /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, displayName);
}
export default OwnerText;